import axios from 'axios';

const rawBaseURL = process.env.REACT_APP_API_URL?.trim();
const normalizedBaseURL = rawBaseURL
  ? `${rawBaseURL.replace(/\/+$/, '').replace(/\/api$/, '')}/api`
  : 'https://static.74.53.235.167.clients.your-server.de/api';

const APIService = axios.create({
  baseURL: normalizedBaseURL,
});

export { APIService };
